module.exports = __webpack_public_path__ + "img/logo_full_small_white.144775fc.png";